import React, { useState, useContext } from "react";
import ReactDOM from "react-dom";
import { trackSuiteEvent } from "shared/util/track";
import { DemoLeadCaptureContext } from "./DemoLeadCaptureContext";
import DemoMobilePreview from "./DemoMobilePreview";
import "./LeadCaptureModal.css";
import "./DemoMobilePreview.css";

/**
 * Persistent "Driver & parent apps" control. Opens screenshots of the mobile
 * apps so the live web demo is not only the dispatcher dashboard.
 *
 * Store links are intentionally omitted: the public Play listing is still
 * Servistesin, and mobile login is phone+SMS (not the web demo password).
 */
const DemoMobilePeek = () => {
  const { openKeepAccount } = useContext(DemoLeadCaptureContext);
  const [open, setOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(false);

  const handleOpen = () => {
    trackSuiteEvent("Demo — Mobile Apps Peek", "button_click");
    setOpen(true);
  };

  const navy = "var(--color-primary-surface, #1d3469)";

  const modal = open
    ? ReactDOM.createPortal(
        <div
          className="lead-capture-overlay"
          onClick={(e) => {
            if (e.target === e.currentTarget) setOpen(false);
          }}
          role="presentation"
        >
          <div
            className="lead-capture-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="demo-mobile-peek-title"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="lead-capture-header">
              <button
                type="button"
                className="lead-capture-close"
                onClick={() => setOpen(false)}
                aria-label="Close dialog"
              >
                ×
              </button>
              <h3 id="demo-mobile-peek-title">The same routes, on phones</h3>
              <div className="lead-capture-subtitle">
                <p>
                  You&apos;re in the dispatcher dashboard. Drivers start the route and share GPS from
                  the driver app. Parents see only their child&apos;s bus.
                </p>
              </div>
            </div>
            <div className="lead-capture-body">
              <DemoMobilePreview compact />
              <p className="dmp-peek-note">
                Keep this workspace, then invite drivers and parents by phone number. They see live
                tracking on the mobile app — the same routes you just opened on the dashboard.
              </p>
              <button
                type="button"
                className="lead-capture-submit lead-capture-submit--full"
                onClick={() => {
                  setOpen(false);
                  if (openKeepAccount) openKeepAccount();
                }}
              >
                Keep this account — it&apos;s free
              </button>
            </div>
          </div>
        </div>,
        document.getElementById("modal-hook") || document.body,
      )
    : null;

  if (collapsed) {
    return (
      <>
        <button
          type="button"
          onClick={handleOpen}
          aria-label="Driver and parent apps"
          title="Driver and parent apps"
          style={{
            position: "fixed",
            left: "20px",
            bottom: "94px",
            zIndex: 99990,
            width: "52px",
            height: "52px",
            borderRadius: "50%",
            border: "none",
            background: navy,
            color: "#fff",
            cursor: "pointer",
            boxShadow: "0 8px 24px rgba(0,0,0,0.22)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "22px",
          }}
        >
          📱
        </button>
        {modal}
      </>
    );
  }

  return (
    <>
      <div
        style={{
          position: "fixed",
          left: "20px",
          bottom: "88px",
          zIndex: 99990,
          display: "flex",
          alignItems: "center",
          gap: "8px",
          background: navy,
          color: "#fff",
          borderRadius: "999px",
          padding: "10px 14px 10px 16px",
          boxShadow: "0 8px 24px rgba(0, 0, 0, 0.22)",
        }}
      >
        <button
          type="button"
          onClick={handleOpen}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            background: "transparent",
            border: "none",
            color: "#fff",
            cursor: "pointer",
            fontSize: "14px",
            fontWeight: 600,
            padding: 0,
          }}
        >
          <span
            aria-hidden="true"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: "26px",
              height: "26px",
              borderRadius: "50%",
              background: "#fbe122",
              color: "#1d3469",
              fontSize: "15px",
            }}
          >
            📱
          </span>
          Driver & parent apps
        </button>
        <button
          type="button"
          onClick={() => setCollapsed(true)}
          aria-label="Minimize"
          title="Minimize"
          style={{
            background: "rgba(255,255,255,0.15)",
            border: "none",
            color: "#fff",
            cursor: "pointer",
            width: "22px",
            height: "22px",
            borderRadius: "50%",
            fontSize: "14px",
            lineHeight: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          ×
        </button>
      </div>
      {modal}
    </>
  );
};

export default DemoMobilePeek;
